module.exports = __webpack_public_path__ + "img/notifications/emoji-9f1f9c4d8763cfdc324d58d337dec6ed.svg";